import { render, staticRenderFns } from "./Purchases.vue?vue&type=template&id=39663c96&scoped=true&"
import script from "./Purchases.vue?vue&type=script&lang=js&"
export * from "./Purchases.vue?vue&type=script&lang=js&"
import style0 from "./Purchases.vue?vue&type=style&index=0&id=39663c96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39663c96",
  null
  
)

export default component.exports